import { clearState, loadState, saveState } from '@/utils/LocalStorage';
import { ILocation } from '../Models/ILocation';

interface NavigationContext {
    from: string;
    breadcrumbs: ILocation[];
}
export class NavigationContextService {
    private static STORAGE_KEY = 'app_navigation_context';

    public static saveNavigationContext(from: string, breadcrumbs: ILocation[]) {
        const context = {
            from,
            breadcrumbs,
        };

        saveState(this.STORAGE_KEY, context);
    }

    public static getNavigationContext() {
        const context = loadState<NavigationContext>(this.STORAGE_KEY);

        return context;
    }

    public static clearNavigationContext() {
        clearState(this.STORAGE_KEY);
    }
}
